
(function (angular) {
    'use strict';

    angular.module('app')
    
     

        /*
        SBLOAD
        
         *
         */
        .directive('sbLoad', ['$parse', function ($parse) {
            return {
            restrict: 'A',
            link: function (scope, elem, attrs) {
                var fn = $parse(attrs.sbLoad);
                elem.on('load', function (event) {
                scope.$apply(function() {
                    fn(scope, { $event: event });
                });
                });
            }
            };
        }])

        /**
         LOADING
         html element
         it handles loading data in app, displays or hide spinner image
         */
        .directive('loading', ["$http", 'sharedDataService', function ($http, sharedDataService) {
            return {
                restrict: 'E',
                link: function (scope, elm, attrs) {
                    scope.isLoading = function () {
                        var counter = 0;
                        for (var i in $http.pendingRequests) {
                            if ($http.pendingRequests[i].async) {
                                counter++;
                            }

                        }
                        if (counter == $http.pendingRequests.length) {
                            return sharedDataService.spinning;
                        }
                        return true;

                    };
                    scope.$watch(scope.isLoading, function (v) {
                        if (v) {
                            elm.css('display', 'block');
                        } else {
                            elm.css('display', 'none');
                        }
                    });
                }
            };

        }])

        /**
         * 
         * Delete this + partials/home.html ??
         */

        // .directive('showMore', ['$compile', function ($compile) {
        //     return {
        //         restrict: 'A',
        //         template: '',
        //         replace: false,
        //         link: function (scope, elm, attrs) {
        //             scope.hidden = true;
        //             var fontSize = elm.css("line-height").replace('px', '');
        //             if (elm.height() > fontSize * attrs.showMore) {
        //                 var text = elm[0].innerHTML;
        //                 elm[0].innerHTML = '';
        //                 var content = '<div class="o-hidden" ng-style="hidden ? {\'height\' : \'' + fontSize * attrs.showMore + 'px\'} : {\'height\': \'inherit;\'}">' + text + '</div><a class="pull-right" ng-show="hidden" href="" ng-click = "hidden = false">show more ...</a><a class="pull-right" ng-show="!hidden" href="" ng-click = "hidden = true">... show less</a>';
        //                 content = $compile(content)(scope);
        //                 elm.append(content);
        //             }
        //         },
        //         scope: {
        //         }
        //     };
        // }])

        /**
         * COMAPI REQUIRED
         * in forms: add this atribute in div with required input in it to check if it's valid; if not - display a message.
            
         input:
            elm: div with input
            attrs: form name value with div in it

         result:
            for selected div: 
            add ng-class
            add <small> element, it shows when input was touched and it's invalid
            remove this attribute
         * 
         * */  
        .directive('comapiRequired', ['$compile', function ($compile) {
            return {
                restrict: 'A',
                scope: false,
                link: function (scope, elm, attrs) {
                    var element, name, addClass;
                    if ((element = elm.find('input')).length !== 0) {
                        name = element.attr('name');
                    }
                    else if ((element = elm.find('select')).length !== 0) {
                        name = element.attr('name');
                    }
                    else if ((element = elm.find('textarea')).length !== 0) {
                        name = element.attr('name');
                    }
                    elm.attr('ng-class', "{ 'has-error': (" + attrs.comapiRequired + '.' + name + ".$touched && !" + attrs.comapiRequired + '.' + name + ".$valid)}");
                    if (elm.find('a').length > 0) {
                        addClass = "p-l-10";
                    }
                    elm.append('<small ng-show="' + attrs.comapiRequired + '.' + name + '.$touched && !' + attrs.comapiRequired + '.' + name + '.$valid" class="help-block ' + addClass + '">This field is required</small>');
                    elm.removeAttr('comapi-required');
                    $compile(elm)(scope);
                }
            };
        }])
        /**
         * DOWNLOAD FILE
         global element in html - index.html
         prepare data to download, watches for broadcast 'fileDownload' with data.

         input:
            element in index.html

         result:
          handles downloading data, add data to form and submit action
         * 
         * */ 
        .directive('downloadFile', ['growlService', function (growlService) {
            return {
                restrict: 'E',
                replace: false,
                template: "<iframe style='position:fixed;display:none;top:-1px;left:-1px;' />",
                link: function (scope, element) {

                    function handleMessage(event) {
                        if (event.data.messageType === 'downloadFileError') {
                            growlService.danger("File wasn't downloaded due to: " + event.data.statusCode + " " + event.data.statusMessage);
                        }
                    }
                    window.addEventListener("message", handleMessage);

                    scope.$on("fileDownload", function (e, fileToDownload) {
                        var data = JSON.stringify(fileToDownload.data) || '';
                        var httpVerb = fileToDownload.httpVerb || '';
                        var dataType = fileToDownload.dataType || '';
                        var acceptHeaders = fileToDownload.acceptHeaders || "";

                        var iframe = angular.element.find('iframe'),
                            iframeBody = iframe[0].contentWindow.document.body,
                            form = angular.element("<form method='POST' action='./downloadFile'>" +
                                "<input type='hidden' name='url' value='" + fileToDownload.url + "' />" +
                                "<input type='hidden' name='data' value='" + data + "' />" +
                                "<input type='hidden' name='httpVerb' value='" + httpVerb + "' />" +
                                "<input type='hidden' name='dataType' value='" + dataType + "' />" +
                                "<input type='hidden' name='fileName' value='" + fileToDownload.fileName + "' />" +
                                "<input type='hidden' name='token' value='" + fileToDownload.token + "' />" +
                                "<input type='hidden' name='acceptHeaders' value='" + acceptHeaders + "' />" +
                                "</form>");
                        iframeBody.appendChild(form[0]);
                        form.submit();
                        form.remove();
                    });

                    scope.$on('$destroy', function () {
                        window.removeEventListener("message", handleMessage);
                    });
                }
            };
        }])
        /**
         * STATIC INCLUDE
         used in profileField directive template; 

         input:
           templateURL

         result:
            load template async?
         * 
         * */ 
        .directive('staticInclude', ['$http', '$templateCache', '$compile', function ($http, $templateCache, $compile) {
            return {
                restrict: 'A',
                replace: false,
                link: function (scope, element, attrs) {
                    attrs.$observe('staticInclude', function () {
                        var templatePath = attrs.staticInclude;
                        if (templatePath.length > 0) {
                            $http.get(templatePath, { cache: $templateCache, async: true }).then(function onSuccess(response) {
                                var contents = element.html(response.data).contents();
                                $compile(contents)(scope);
                            });
                        }
                    });
                }
            };

        }])
        /**
         * COMAPI DATA LIST
         attributes on <input> element;
         alternative for dropdown -> hint when typing

         input:
           comapiDataListCallback: function,
           comapiDataListItems: array,
           comapiDataListParam: $index,
           comapiDataListProperty: string,

         result:
          ngModel <- picked value from dropdown
         * 
         * */ 
        .directive('comapiDataList', ['$timeout', function ($timeout) {
            return {
                restrict: 'A',
                replace: true,
                scope: {
                    //callback that fire after picking new variable (usually same functions as in ng-change)
                    comapiDataListCallback: '=',
                    //callback is fired with only this one param (usually index)
                    comapiDataListParam: '=',
                    //list of elements to be listed in dropdown 
                    comapiDataListItems: '=',
                    //if list of elements is list of objects specify property name that you want to display
                    comapiDataListProperty: '=',
                    ngModel: '=',
                },
                link: function (scope, elem) {
                    var datalist;
                    function callback(val) {
                        scope.ngModel = val;
                        scope.$apply();
                        if (scope.comapiDataListCallback) {
                            scope.comapiDataListCallback(scope.comapiDataListParam);
                            scope.$apply();
                        }

                    }
                    $timeout(function () {
                        if (elem.relevantDropdown) {
                            var items = scope.comapiDataListItems;
                            if (scope.comapiDataListProperty && items) {
                                items = scope.comapiDataListItems.map(function (a) { return a[scope.comapiDataListProperty]; });
                            }
                            datalist = elem.relevantDropdown({ callback: callback, datalistItems: items });
                        }
                    });
                    elem.on('$destroy', function () {
                        if (datalist) {
                            datalist.remove();
                        }
                    });
                }
            };
        }])
        /**
         * MY SRC
         <img> attribute; adding default img source if src doesn't exist
         shows spinner when image is loading

         input:
          my-src: URL of image
          default-src: URL of default image
          
         * */ 
        .directive("mySrc", function () {
            return {
                link: function (scope, element, attrs) {
                    var img, loadImage;
                    img = null;

                    loadImage = function () {
                        //TODO replace it with spinner
                        element[0].src = "./assets/img/imageLoader.gif";

                        img = new Image();
                        img.src = attrs.mySrc;

                        img.onload = function () {
                            element[0].src = attrs.mySrc;
                        };
                        img.onerror = function () {
                            if (attrs.defaultSrc) {
                                element[0].src = attrs.defaultSrc;
                            }
                        };
                    };
                    if (attrs.mySrc) {
                        loadImage();
                    }
                    else {
                        if (attrs.defaultSrc) {
                            element[0].src = attrs.defaultSrc;
                        }
                        scope.$watch((function () {
                            return attrs.mySrc;
                        }), function (newVal, oldVal) {
                            if (oldVal !== newVal) {
                                loadImage();
                            }
                        });
                    }
                }
            };
        })
        /**
         * DISALLOW SPACES
         * attribute on <input> element;

         input:
          <input> element

         result:
          replace it's value with a value without whitespaces
         * 
         * */ 
        .directive('disallowSpaces', function () {
            return {
                restrict: 'A',

                link: function ($scope, $element) {
                    $element.bind('input', function () {
                        $element.val($element.val().replace(/ /g, ''));
                    });
                }
            };
        })
         /**
         * CHECK IMAGE
         
         input:
          image URL

         result:
         add image src if error appears
         * 
         * */ 
        .directive('checkImage', function () {
            return {
                link: function (scope, element, attrs) {
                    element.bind('error', function () {
                        element.attr('src', attrs.checkImage);
                    });
                }
            }
        })
          /**
         * AUTOFOCUS
         autofocus on an element;

         input:
          boolean value or number

         result:
          autofocus when true or set timeout when it's number
         * 
         * */ 
        .directive('autoFocus', ['$timeout', function ($timeout) {
            return {
                restrict: 'A',
                scope: {
                    autoFocus: '='
                },
                link: function ($scope, $element) {
                    $scope.$watch('autoFocus', function (focus) {
                        var timeout = (focus === parseInt(focus, 10) ? focus : 0);   
                        if (focus) {
                            $timeout(function () {
                                $element[0].focus();
                            }, timeout);
                        }
                    });
                }
            }
        }])

        /**
         * CHANNEL ALLOWED
         input:
          channel id 

         result:
          will hide / show object under it based on data in channelsProvider
         * 
         * */ 
        .directive('channelAllowed', ['channelsProvider', function(channelsProvider){
            return {
                link: function (scope, element, attrs) {
                    var channelId = scope.$eval(attrs.channelAllowed)
                    if(channelsProvider[channelId] && !channelsProvider[channelId].allowed){
                        element.css('display', 'none');
                    }
                }
            }
        }])
        /**
         * CHANNEL READ PERMITTED
         input:
          channel id 

         result:
          will hide / show object based on data in channelsProvider and channel read permissions
         * 
         * */ 
        .directive('channelReadPermitted', ['channelsProvider','permittedChannels', function (channelsProvider, permittedChannels) {
            return {
                link: function (scope, element, attrs) {
                    var channelId = scope.$eval(attrs.channelReadPermitted);
  
                    if (channelsProvider[channelId] && !permittedChannels.canRead(channelId)) {
                        element.css('display', 'none');
                    }
                }
            }
        }])
        /**
         * CHANNEL WRITE PERMITTED
         input:
          channel id 

         result:
          will hide / show object based on data in channelsProvider and channel write permissions
         * 
         * */ 
           .directive('channelWritePermitted', ['channelsProvider','permittedChannels', function (channelsProvider, permittedChannels) {
            return {
                link: function (scope, element, attrs) {
                    var channelId = scope.$eval(attrs.channelWritePermitted);
  
                    if (channelsProvider[channelId] && !permittedChannels.canWrite(channelId)) {
                        element.css('display', 'none');
                    }
                }
            }
        }]);
})(window.angular);